import { configureStore } from "@reduxjs/toolkit";
import alertSlice from "./alert/slice";
import authSlice from "./auth/slice";
import organizationSlice from "./organization/slice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { amplitudeExceptionMiddleware } from "./amplitudeExceptionMiddleware";

const persistConfig = {
  key: "root",
  storage,
};

const persistedAuthReducer = persistReducer(persistConfig, authSlice.reducer);
const persistedOrgReducer = persistReducer(
  persistConfig,
  organizationSlice.reducer,
);

export const store = configureStore({
  reducer: {
    [alertSlice.name]: alertSlice.reducer,
    [authSlice.name]: persistedAuthReducer,
    [organizationSlice.name]: persistedOrgReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(amplitudeExceptionMiddleware),
});

// @ts-ignore
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const Persistor = persistStore(store);
